import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import config from "../../../config/common";
import RowContainer from "./RowContainer";
import Row from "./Row";
import Cell from "./Cell";
import Arrow from "./Arrow";
import Direction from "./Direction";
import HeightBar from "./HeightBar";
import Label from "./Label";
import ValueWrapper from "./ValueWrapper";
import BarWrapper from "./BarWrapper";
import WindRow from "./WindRow";

const SpotDataListItem = props => {
  const { date, height, peakPeriod, direction, spotName } = props;
  const period = Number(peakPeriod).toFixed(1);
  const error =
    peakPeriod > 20 || height > 12 || (peakPeriod > 16 && height > 8);
    const buoyTime = moment(date)
    .add(config.timeCorrection, "hours")
    .format("HH:mm");
  return (
    <RowContainer><Row error={error}>
      <Cell>
        <time dateTime={date}>
          {buoyTime}
        </time>
      </Cell>
      <Cell>
        <ValueWrapper>
          {Number(height).toFixed(2)}
          <Label>m</Label>
        </ValueWrapper>
        <BarWrapper>
          <HeightBar height={Number(height).toFixed(2)} />
        </BarWrapper>
      </Cell>
      <Cell bold={parseInt(period) >= 8}>
        {period}
        <Label>sec</Label>
      </Cell>
      <Cell>
        <Arrow direction={parseInt(Number(direction).toFixed(0))} />
        <Direction>{Number(direction).toFixed(0)}º</Direction>
      </Cell>
      
    </Row>
    <WindRow spotName={spotName} time={buoyTime} /></RowContainer>
  );
};

SpotDataListItem.propTypes = {
  direction: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  peakPeriod: PropTypes.string.isRequired
};

export default SpotDataListItem;
